module.exports = __webpack_public_path__ + "static/media/exclamation-square.619f0ee5.svg";